import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';


const passwordRequirements = [
  {
    label: 'At least 8 characters',
    test: (pw) => pw.length >= 8,
  },
  {
    label: 'At least 1 uppercase letter',
    test: (pw) => /[A-Z]/.test(pw),
  },
  {
    label: 'At least 1 number',
    test: (pw) => /[0-9]/.test(pw),
  },
  {
    label: 'At least 1 special character',
    test: (pw) => /[^A-Za-z0-9]/.test(pw),
  },
];

const ChangePassword = () => {
  const [newPassword, setNewPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const isPasswordValid = passwordRequirements.every((req) => req.test(newPassword));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isPasswordValid) {
      setError('Password does not meet requirements.');
      return;
    }
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch('/api/change-password', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ newPassword })
      });

      if (!response.ok) throw new Error('Failed to change password');

      alert('Password changed successfully');
      navigate('/login');
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="change-password-container">
      <h2>Change Password</h2>
      {error && <div className="error-message">{error}</div>}
      <form onSubmit={handleSubmit}>
        <input
          type="password"
          placeholder="New Password"
          value={newPassword}
          onChange={(e) => {
            setNewPassword(e.target.value);
            setError('');
          }}
        />
        <ul className="password-requirements" style={{ listStyle: 'none', padding: 0, margin: '10px 0' }}>
          {passwordRequirements.map((req, idx) => {
            const met = req.test(newPassword);
            return (
              <li key={idx} style={{ color: met ? 'green' : 'red', fontWeight: met ? 'bold' : 'normal' }}>
                {met ? '✔' : '✖'} {req.label}
              </li>
            );
          })}
        </ul>
        <button type="submit" disabled={!isPasswordValid}>Change Password</button>
      </form>
    </div>
  );
};

export default ChangePassword;